export default __webpack_public_path__ + "static/media/pv-6.3230d9d9.png";